<h2 mat-dialog-title>Réception Document HUB</h2>
<mat-dialog-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-dialog-content>
              <mat-table #table [dataSource]="ehealth.transactions.list" class="ehealth-transactionlist">
                <ng-container matColumnDef="source">
                  <mat-header-cell *matHeaderCellDef> Source </mat-header-cell>
                  <mat-cell *matCellDef="let transaction">
                    <div class="row" style="font-weight: bold;">
                      <div class="col-sm-7">
                        {{getTransactionDesc(transaction)}}
                      </div>
                      <div class="col-sm-3" style="text-align: right;font-size: 10px;">
                          {{getTransactionDate(transaction)}}
                      </div>
                    </div>
                    <div class="row" style="font-size:11px;">
                      <div class="col-sm-12">
                          {{getTransactionAuthors(transaction)}}
                      </div>
                    </div>
                    <div class="row" style="font-weight: bold;font-size: 10px;">
                      <div class="col-sm-12">
                          {{getTransactionType(transaction)}}
                      </div>
                    </div>
                  </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let transaction; columns: displayedColumns;" (click)="selectTransaction(transaction)" style="padding-right: unset;padding-left: unset;"></mat-row>
              </mat-table>
        </mat-dialog-content>
      </div>
      <div class="col-sm-7">
        <mat-dialog-content>
          <div *ngIf="transaction.images">
            <div *ngFor="let image of transaction.images">
              <img style="width:100%;" [src]="image.url">
            </div>
          </div>
        </mat-dialog-content>
      </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close class="btn btn-danger">Fermer</button>
  <button mat-button mat-dialog-close class="btn btn-success" (click)="okButtonClicked()">{{okButtonLabel}}</button>
</mat-dialog-actions>
